<template>
  <admin title="Licenças" menu="Licenças">
    <div class="row">
      <div class="col-lg-8 col-xs-12">
        <h1>Dados da conta</h1>
        <div class="bg_black color-light-grey">
          <div class="card mt-3">
            <div class="card-body">
              <div class="color-light-grey" style="text-align: left !importante;">
                <p>{{account.business.name}}</p>

                <p>
                  Data de criação:
                  <b>{{account.created_at | moment('DD/MM/YYYY')}}</b>
                </p>
                <p>
                  Data de atualização:
                  <b>{{account.updated_at | moment('DD/MM/YYYY')}}</b>
                </p>
                <p>
                  Tipo de conta:
                  <b>{{account.type_account}}</b>
                  <br />
                  <button
                    v-if="account.type_account == 'premium'"
                    type="button"
                    class="btn btn-danger mt-1 mb-2"
                    @click="update(0)"
                  >Bloquear licença</button>
                </p>
                <p>
                  Data de encerramento do acesso free:
                  <b>{{account.date_free | moment('DD/MM/YYYY')}}</b>
                </p>
                <hr />
                <p>
                  CPF/CNPJ:
                  <b>{{account.document_number}}</b>
                </p>
                <p>
                  Rua:
                  <b>{{account.street}}</b>
                </p>
                <p>
                  Bairro:
                  <b>{{account.neighborhood}}</b>
                </p>
                <p>
                  Cep:
                  <b>{{account.zipcode}}</b>
                </p>
                <p>
                  Número:
                  <b>{{account.street}}</b>
                </p>
                <p>
                  telefone:
                  <b>{{account.phone}}</b>
                </p>
                <p>
                  Cidade:
                  <b>{{account.city}} / {{account.state}}</b>
                </p>
                <hr />
              </div>
            </div>
          </div>
        </div>

        <h1 class="mt-5" v-if="account.plan">Plano</h1>
        <div v-if="account.plan" class="bg_black color-light-grey">
          <div class="card mt-3">
            <div class="card-body">
              <p>
                Plano:
                <b>{{account.plan ? account.plan.name : 'Sem plano'}}</b>
              </p>

              <p>
                Quantidade de vaga:
                <b>{{account.plan ? account.plan.amount_jobs : '0'}}</b>
              </p>
              <p>
                Quantidade de recrutadores:
                <b>{{account.plan ? account.plan.amount_recruiters : '0'}}</b>
              </p>
              <p>
                Valor:
                <b v-if="account.plan">
                  R$
                  {{ account.plan.price ? parseFloat(account.plan.price).toFixed(2).replace('.', ',') : "0,00" }}
                </b>
              </p>
            </div>
          </div>
        </div>

        <h1 class="mt-5" v-if="subscriptions.length > 0">Inscrições</h1>
        <div
          v-for="subscription in subscriptions"
          :key="subscription.id"
          class="bg_black color-light-grey"
        >
          <div class="card mt-3">
            <div class="card-body">
              <p>
                Plano:
                <b>{{subscription.plan.name}}</b>
              </p>
              <p>
                Tipo de pagamento:
                <b>{{subscription.payment_method == 'boleto' ? 'boleto' : 'Cartão de crédito'}}</b>
              </p>
              <p>Data da assinatura: {{subscription.created_at | moment('DD/MM/YYYY')}}</p>
              <p>
                Valor:
                <b>
                  R$
                  {{ subscription.plan.price ? parseFloat(subscription.plan.price).toFixed(2).replace('.', ',') : "0,00" }}
                </b>
              </p>
              <p>
                Status do pagamento:
                <b>{{status[subscription.status]}}</b>
              </p>
              <button
                v-show="account.plan_id == 0"
                type="button"
                @click="update(subscription.plan_id)"
                class="btn btn-primary"
              >Aprovar conta</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-lg-4">
        <h2 class="mb-1 mt-2">Registros da Licença</h2>
        <div class="bg_black mt-1 color-light-grey">
          <div class="card mt-3">
            <div class="card-body">
              <div class="color-light-grey">
                <p>
                  Total de vagas:
                  <b>{{amount_jobs}}</b>
                </p>
                <p>
                  Total de Recrutadores:
                  <b>{{amount_recruiters}}</b>
                </p>
              </div>
            </div>
          </div>
        </div>
        <h2 class="mb-1 mt-5">Recrutadores</h2>
        <div
          v-for="recruiter in recruiters"
          :key="recruiter.id"
          class="bg_black mt-1 color-light-grey"
        >
          <div class="card mt-3">
            <div class="card-body">
              <div class="color-light-grey">
                <p>
                  {{recruiter.name}}
                  <br />
                  {{recruiter.email}}
                  <br />
                  <span
                    v-if="recruiter.recruiter_admin_id == 0"
                    class="process3 mt-2 block_process"
                  >Admin</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <h2 class="mb-1 mt-5">Habilidar plano</h2>
        <div class="bg_black mt-1 color-light-grey">
          <div class="card mt-3">
            <div class="card-body">
              <div class="color-light-grey">
                <select v-model="plan_id_select" class="form-control">
                  <option v-for="plan in plans" :value="plan.id" :key="plan.id">{{plan.name}}</option>
                </select>
                <button
                  type="button"
                  @click="update(plan_id_select)"
                  class="mt-2 btn btn-success full"
                >Salvar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </admin>
</template>

<script>
export default {
  props: [
    "account",
    "amount_jobs",
    "amount_recruiters",
    "recruiters",
    "subscriptions",
    "plans",
  ],
  data: () => ({
    plan_id_select: 1,
    status: {
      processing: "Processo de autorização.",
      authorized: "Autorizada.",
      unpaid: "Não foi pago",
      paid: "Paga.",
      refunded: "Estornada",
      trialing: " Aguardando pagamento ",
      waiting_payment: " Aguardando pagamento ",
      pending_refund: "Estorno solicitado.",
      refused: "Não autorizada.",
      chargedback: "Transação sofreu chargeback.",
      analyzing: " Análise ",
      pending_review: "Pendente",
    },
  }),
  mounted() {},
  methods: {
    update(plan_id) {
      let conf = confirm("Tem certeza que deseja atualizar essa conta?");
      if (!conf) return;
      axios
        .put("/admins/accounts/" + this.account.id, {
          accounts: {
            plan_id: plan_id,
          },
        })
        .then((response) => {
          this.$toast.success("Status mudado com sucesso");
          this.$inertia.visit("/admins/accounts/" + this.account.id, {
            method: "get",
            data: {},
            replace: true,
            preserveState: false,
            preserveScroll: true,
            only: [],
          });
        });
    },
  },
};
</script>

<style>
</style>